import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Regions',
	url: '/regions',
	icon: 'map',
}];

export default class Regions extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button data-id="add-region" onClick={this.toggle('modalRegion')} size="sm" color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Region
					</Button>
				</Framework.Components.PageBar>

				<Collections.Regions
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Region"}
					object={Objects.Region}
					history={this.props.history}
					toggle={this.state.modalRegion}
					reportClose={this.reportClose('modalRegion')}
					afterSave={() => this.setState({refresh: !this.state.refresh})}
					size={'md'}

				/>

			</div>
		);
	}
}

